import React, { useEffect, useState, useRef } from "react";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import { BASE_URL,BASE_IMAGE_URL } from "../../service/apiConfig";
import {
  Select,
  Typography,
  Space,
  Button,
  Table,
  Modal,
  Form,
  Input,
  notification,
  Upload,
  message,
  Card,
  DatePicker,
  Row,
  Col,
} from "antd";
import moment from "moment";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import countriesApi from "../../service/countriesApi";
import locationTourApi from "../../service/locationTourService";
// import eventServiceApi from "../../service/locationserviceService";
import eventServiceApi from "../../service/eventService";
import provinceApi from "../../service/provinceService";
import providerApi from "../../service/providerService";
import eventCategoryApi from "../../service/eventCategoriesService";
import adminService from "../../service/adminService";
import {
  EditorState,
  convertToRaw,
  ContentState,
  convertFromHTML,
} from "draft-js";
// import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";
import "./management.css";
import draftToHtml from "draftjs-to-html";
import MapManagement from "./MapManagement";
import { useSelector } from "react-redux";
// import htmlToDraft from "html-to-draftjs";
import isEqual from 'lodash/isEqual';
import get from 'lodash/get';

const { TextArea } = Input;
const { Option } = Select;
export default function ManagementPage() {
  const [fileList, setFileList] = useState([]);
  const [fileListSubmit, setFileListSubmit] = useState([]);

  const [desData, setDesData] = useState("");
  const [providerId, setProviderId] = useState(0);
  const currentLocation = useSelector((state) => state.currentLocation);
  const [dataChange, setDataChange] = useState(true);
  const [isShowUpdateProvider, setIsShowUpdateProvider] = useState(false);

  const [listProvince, setListProvince] = useState([]);

  const [listCountry, setListCountry] = useState([]);
  const [listEventCategory, setListServiceCategory] = useState([]);

  const [fileListService, setFileListService] = useState([]);
  const [fileListServiceSubmit, setFileListServiceSubmit] = useState([]);

  const [loading, setLoading] = useState(false);
  const [invalidImage, setInvalidImage] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [imagePath, setImagePath] = useState("");
  const [providerData, setProviderData] = useState();
  const [centerMap, setCenterMap] = useState({
    lat: "",
    lng: "",
  });
  const { id } = useParams();
  const [form] = Form.useForm();
  const [formService] = Form.useForm();
  const [instroductionContent, setInstroductionContent] = useState("");
  const [editorStateInstroduction, setEditorStateInstroduction] = useState(
    () => {
      const blocksFromHTML = convertFromHTML(instroductionContent);
      const contentState = ContentState.createFromBlockArray(
        blocksFromHTML.contentBlocks,
        blocksFromHTML.entityMap
      );
      return EditorState.createWithContent(contentState);
    }
  );

  useEffect(() => {    
    getAllProvider();
  }, []);

  const onEditorStateChangeInstroduction = (editorState) => {
    setEditorStateInstroduction(editorState);
  };

  const onFormValueChange = () =>{
    setDataChange(true)
  }

  const onLocationChange = (location) => {
    setDataChange(true)
    formService.setFieldsValue({
      latitude:location.lat,
      longitude:location.lng,
    });
  }  

  const getAllProvider = () => {
    providerApi.getAll().then((res) => {
      setListProvince(res.data);
    });
  };

  const deleteProvince = () => {
    console.log(555);
    providerApi.delete(providerId).then((res) => {
      notification.success({ message: `Delete province success` });
      getAllProvider();
      setOpenDeleteDialog(false);
    });
  };

  const openModalService = (id) => {
    setProviderId(id);
    if (id) {      
      providerApi.getById(id).then((res) => {
        setProviderData(res.data);
        setCenterMap({
          lng: res.data.longitude,
          lat: res.data.latitude,
        });
        formService.setFieldsValue({
          name: res.data.name,
          address: res.data.address,
          phone: res.data.phone,
          textContentId: res.data.textContentId,
          description: res.data.description,
          longitude: res.data.longitude,
          latitude: res.data.latitude,
        });
        setIsShowUpdateProvider(true);
        const pictureFilenameParse = JSON.parse(res.data.pictureFilename);

        const files = [];
        const filesSubmit = [];
        if (pictureFilenameParse.length > 0) {
          pictureFilenameParse.forEach((item) => {
            files.push({ url: BASE_IMAGE_URL + item });
            filesSubmit.push(item);
          });
        }
        setFileList(files);
        setFileListSubmit(filesSubmit);
      });
    }
  };

  const onChangeDes = (value) => {
    setDesData(value.target.value);
  };

  const onCloseModalService = () => {
    setIsShowUpdateProvider(false);
    setFileListService([]);
    setFileListServiceSubmit([]);
    setCenterMap('')
    formService.setFieldsValue({
      name: "",
      phone: null,
      longitude: "",
      latitude: "",
      address: null,
      description: null,
      textContentId: null,
    });
    setProviderData(null);
  };

  const getEventCategories = () => {
    eventCategoryApi.getAll().then((response) => {
      setListServiceCategory(response.data);
    });
  };

  const layout = {
    labelCol: { span: 5 },
    wrapperCol: { span: 20 },
  };

  const openDeleteService = (id) => {
    setProviderId(id);
    setOpenDeleteDialog(true);
  };
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };
  const getColumnSearchProps = (dataIndex, placeHolderSearch) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div
        style={{
          padding: 8,
        }}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${placeHolderSearch}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Tìm kiếm
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Đặt lại
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({
                closeDropdown: false,
              });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Lọc
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1890ff" : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
    get(record, dataIndex)
    .toString()
    .toLowerCase()
    .includes(value.toLowerCase()),
      // record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      isEqual(searchedColumn, dataIndex) ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text?.toString() : ""}
        />
      ) : (
        text
      ),
  });
  const columnsService = [
    {
      title: "Nhà cung cấp",
      dataIndex: "name",
      key: "name",
      ...getColumnSearchProps("name", "nhà cung cấp"),

      
    },
    {
      title: "Địa chỉ",
      dataIndex: "address",
      key: "address",
      ...getColumnSearchProps("address", "địa chỉ"),
    },
    {
      title: "Số điện thoại",
      dataIndex: "phone",
      key: "phone",
      ...getColumnSearchProps("phone", "số điện thoại"),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Button
            type="primary"
            style={{
              borderRadius: 8,
            }}
            onClick={() => openModalService(_.id)}
          >
            Sửa
          </Button>
          <Button
            type="danger"
            style={{
              borderRadius: 8,
            }}
            onClick={() => openDeleteService(_.id)}
          >
            Xóa
          </Button>
        </Space>
      ),
    },
  ];
  const getUserInfo = () => {
    const user = adminService.AuthService.getCurrentUser()
    return user
  }

  const onFinishHandleService = (values) => {
    
    values.pictureFilename = fileListSubmit;
    const user = getUserInfo()
    values.userId = user?.id
    if (providerId !== 0) {
      console.log(1212344);
      providerApi.updateById(providerId, values).then((res) => {
        notification.success({ message: "Cập Nhật Nhà Cung Cấp Thành Công" });
        // onCloseModalService();
        getAllProvider();
        onCloseModalService();
      });
    } else {
      providerApi.create(values).then((res) => {
        notification.success({ message: "Tạo Nhà Cung Cấp Thành Công" });
        form.setFieldsValue({
          name: "",
          phone: null,
          address: null,
          textContentId: null,
          description: null,
          longitude: "",
          latitude: "",
        });
        getAllProvider();
        onCloseModalService();
      });
    }
  };

  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        Thêm Ảnh
      </div>
    </div>
  );

  const handleChangeService = async ({ fileList: newFileList }) => {
    if (!invalidImage) {
      onFormValueChange()
      setFileListService(newFileList);
      const urlArray = [];
      const urlArraySubmit = [];
      let checkTotal = 0;
      let check = 0;
      await newFileList.forEach((item) => {
        if (typeof item?.status !== "undefined") {
          checkTotal++;
          if (item.status === "uploading") {
            setLoading(true);
            return;
          }
          if (item.status === "done") {
            check++;
          }
        } else {
          urlArray.push(item);
          urlArraySubmit.push("/images/" + item.url.split("/images/")[1]);
        }
      });
      if (check === checkTotal) {
        newFileList.forEach((item) => {
          if (typeof item?.status !== "undefined") {
            const temp = { url: BASE_IMAGE_URL + item.response.data.url };
            urlArray.push(temp);
            urlArraySubmit.push(item.response.data.url);
          }
        });
      }

      setFileListServiceSubmit(urlArraySubmit);
      setLoading(false);
    }
  };

  const handleChange = async ({ fileList: newFileList }) => {
    if (!invalidImage) {
      onFormValueChange()
      setFileList(newFileList);
      const urlArray = [];
      const urlArraySubmit = [];
      let checkTotal = 0;
      let check = 0;
      await newFileList.forEach((item) => {
        if (typeof item?.status !== "undefined") {
          checkTotal++;
          if (item.status === "uploading") {
            setLoading(true);
            return;
          }
          if (item.status === "done") {
            check++;
          }
        } else {
          urlArray.push(item);
          urlArraySubmit.push("/images/" + item.url.split("/images/")[1]);
        }
      });
      if (check === checkTotal) {
        newFileList.forEach((item) => {
          if (typeof item?.status !== "undefined") {
            const temp = { url: BASE_IMAGE_URL + item.response.data.url };
            urlArray.push(temp);
            urlArraySubmit.push(item.response.data.url);
          }
        });
      }
      setFileListSubmit(urlArraySubmit);
      setLoading(false);
    }
  };

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";

    if (!isJpgOrPng) {
      message.error("You can only upload JPG/PNG file!");
      setInvalidImage(true);
    } else {
      setInvalidImage(false);
    }

    const isLt2M = file.size / 1024 / 1024 < 2;

    return isJpgOrPng;
  };

  // formService.setFieldsValue(
  //   {
  //     latitude:
  //       (currentLocation?.latitude != ""&&providerId===0)
  //         ? currentLocation?.latitude
  //         : providerData?.latitude,
  //     longitude:
  //       (currentLocation?.longitude != ""&&providerId===0)
  //         ? currentLocation?.longitude
  //         : providerData?.longitude,
  //   },
  //   []
  // );

  return (
    <>
      <Card
        title={
          <Typography style={{ textAlign: "center" }}>
            Quản Lý Nhà Cung Cấp
          </Typography>
        }
        extra={
          <Button
            type="primary"
            style={{
              borderRadius: "8px",
            }}
            onClick={() => {
              setIsShowUpdateProvider(true);
              getEventCategories();
            }}
          >
            Tạo Nhà Cung Cấp
          </Button>
        }
      >
        <Table columns={columnsService} dataSource={listProvince} bordered />

        <Modal
          title={providerId !== 0 ? "Cập Nhật Nhà Cung Cấp" : "Tạo Nhà Cung Cấp"}
          visible={isShowUpdateProvider}
          // onOk={handleOkTour}
          width="70%"
          onCancel={() => {
            setProviderId(0);
            onCloseModalService();
            setFileListServiceSubmit([]);
            setFileList([]);

          }}
          footer={[
            <>
              <Button
                size="small"
                onClick={() => {
                  onCloseModalService();
                }}
              >
                {/* Close */}
                Đóng
              </Button>
              <Button
                size="small"
                className="btn btn-primary"
                type="primary"
                form="CU-tour"
                key="submit"
                htmlType="submit"
              >
                Hoàn Thành
              </Button>
            </>,
          ]}
        >
          <Row justify="space-around">
            <Col span={12}>

            <Upload
                name="file"
                listType="picture-card"
                className="avatar-uploader"
                showUploadList={true}
                multiple={true}
                action={BASE_IMAGE_URL + "/api/upload"}
                beforeUpload={beforeUpload}
                onChange={handleChange}
                fileList={fileList}
                // disabled={ language!='vi' }
              >
                {uploadButton}
              </Upload>

              <Form
                {...layout}
                form={formService}
                name="CU-tour"
                onValuesChange ={onFormValueChange}
                onFinish={onFinishHandleService}
              >
                <Form.Item
                  name="name"
                  label="Tên"
                  rules={[{ required: true }]}
                >
                  <Input size="large" />
                </Form.Item>
                <Form.Item name="address" label="Địa chỉ">
                  <Input size="large" />
                </Form.Item>
                <Form.Item name="phone" label="Số điện thoại">
                <Input size="large" />
                </Form.Item>

                <Form.Item
                  name="latitude"
                  label="Latitude"
                  rules={[{ required: true }]}
                >
                  <Input size="large" />
                </Form.Item>
                <Form.Item
                  name="longitude"
                  label="Longitude"
                  rules={[{ required: true }]}
                >
                  <Input size="large" />
                </Form.Item>

                {/* <Form.Item
                name="textContentId"
                label="Text content Id"
              >
                <Input size="large" />
              </Form.Item> */}

              <Form.Item name="description" label="Mô tả"onChange={onChangeDes}>
                <TextArea rows={4} />
              </Form.Item>
              </Form>
            </Col>
            <Col span={10}>
              <MapManagement location={centerMap} onChange = {onLocationChange} ></MapManagement>
            </Col>
          </Row>
        </Modal>
      </Card>
      <Modal
        visible={openDeleteDialog}
        onOk={deleteProvince}
        onCancel={() => {
          setProviderId(0);
          setOpenDeleteDialog(false);
        }}
        title={`Xóa Nhà Cung Cấp`}
      >
        Bạn có chắc muốn xóa nhà cung cấp này?
      </Modal>
    </>
  );
}
